<template>
  <div class="position-relative" @click="$emit('update:modelValue', !modelValue)">
    <HMFixedAspectRatioContainer>
      <div v-if="img && img.thumbnail">
        <img :src="img.thumbnail" class="rounded h-100" />
      </div>
      <div v-else class="img-thumbnail ps-3"></div>
    </HMFixedAspectRatioContainer>
    <HMCheckBox
      class="check-box"
      @click.stop
      style-type="circle"
      :modelValue="modelValue"
      @update:modelValue="newValue => $emit('update:modelValue', newValue)"
    />
    <label class="my-2" :class="{ 'c-brand-color': modelValue }">
      {{ label }}
    </label>
  </div>
</template>

<script lang="ts">
export default {
  name: 'HMImageCheckBoxGroup',
  props: {
    modelValue: {
      type: Boolean,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    img: {
      type: [String, Object],
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.check-box {
  position: absolute;
  left: 1rem;
  top: 1rem;
  background-color: white;
  border-radius: 50%;
}

.img-thumbnail {
  background-color: $light-gray;
}
</style>
